import { observable, action } from "mobx";
import { post, get, deleted, put } from "../services/ajax.service";

class DefaultSettingStore {
  @observable defaultSetting = [];
  @observable default_Setting = {};
  @observable limit = 10;
  @observable tiles = 0;
  @observable setting = false;
  @observable errors = {};
  @observable url = "/api/v1/defaultsettingactions";

  @action setSettingvalue =  value => {
this.setting=value
  }

  @action getDefaultSettings = async data => {
    let defaultSetting = [];
      let response = await get(
        `${this.url}/getall?limit=${this.limit}&&offset=${data.offset}&&search=${data.search}&&attr=${data.attr}`
      );
    this.defaultSetting = response.data.rows;
    let count = parseInt(response.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;

  };


  @action getDefaultSetting = async (id) => {
    this.default_Setting={};
      let response = await get(`${this.url}/get/${id}`);
      this.default_Setting=response.data;
    
    return response.data;
  };

  @action getByBranding = async (id) => {
    try {
    this.default_Setting={};
      let response = await get(`${this.url}/getByBranding/${id}`);
      this.default_Setting=response.data;

      return response.data;
  } catch (e) {
    this.errors = e.response.data;
    return e.response.data;
  }
  };

  @action getAllByBranding = async (label=null) => {
    if(!label) {this.defaultSetting = []; return}
    try {
    this.defaultSetting=[];
      let response = await get(`${this.url}/getAllByBranding/${label}`);
      this.defaultSetting=response.data.rows;
  } catch (e) {
    this.errors = e.response.data;
    return e.response.data;
  }
  };


  @action addDefaultSetting = async (data) => {
    try {
      let  response = await post(`${this.url}/create`, data);   
      return response.data;   
    } catch (e) {
      this.errors = e.response.data;
      return e.response.data
    }
  };

  @action editDefaultSetting = async (data) => {
    try {
       let response= await put(`${this.url}/update/${data.id}`, data);
       return response.data
     
    } catch (e) {
      this.errors = e.response.data;
      return e.response.data
    }
  };


  @action deleteDefaultSetting = async (id) => {
    try {
      let response =await deleted(`${this.url}/delete/${id}`);
      return response.data
    } catch (e) {
      console.log(e);
      return e.response.data
    }
  };
  
}

export default DefaultSettingStore;
